// extracted by mini-css-extract-plugin
export var barMenuItem = "footer-bar-menu-module--barMenuItem--7dafb";
export var barMenuLabel = "footer-bar-menu-module--barMenuLabel--d6910";
export var barMenuSeparator = "footer-bar-menu-module--barMenuSeparator--ebaf3";
export var collapsibleContentBottomMenu = "footer-bar-menu-module--collapsibleContentBottomMenu--4a8c6";